import type { TranslationInterface } from '.';

export const JapaneseLanguage: TranslationInterface = {
  write_a_message_placeholder: 'メッセージを入力...',
  your_issue_has_been_resolved: '問題が解決しました！',
  new_conversation: '新しい会話',
  welcome_screen_title: 'サポートチャットへようこそ',
  welcome_screen_description:
    'お手伝いいたします！会話を開始していただければ、できるだけ早くご連絡いたします。',
  your_name_placeholder: 'お名前',
  your_email_placeholder: 'メールアドレス',
  start_chat_button: 'サポートに相談',
  start_chat_button_loading: '接続中...',
  i_need_more_help: 'さらにサポートが必要です',
  this_was_helpful: '役に立ちました',
  optional: '任意',
  no_conversations_yet: 'まだ会話がありません',
  back_to_conversations: '会話一覧に戻る',
  closed_conversations: '終了した会話',
  csat_title: '会話はいかがでしたか？',
  csat_submitted_title: '会話を次のように評価しました',
  csat_feedback_placeholder: '詳しく教えてください...（任意）',
  follow_up_placeholder: '続けて質問…',
  companion_layout_label: 'レイアウト',
  companion_layout_floating: 'フローティング',
  companion_layout_sidebar: 'サイドバー',
  companion_layout_fullscreen: '全画面',
  companion_close: '閉じる',
  companion_history: '会話履歴',
  companion_expand_chat: 'チャットを拡大',
  companion_sidebar_dock_label: 'ドック',
  companion_sidebar_side_label: '位置',
  companion_sidebar_left: '左',
  companion_sidebar_right: '右',
  companion_resize_chat: 'チャットのサイズを変更',
  scroll_to_bottom: '一番下までスクロール',
  thinking: '考えています…',
  running: '実行中…',
  steps: 'ステップ',
  step_arguments: '引数',
  step_result: '結果',
  attach_files: '画像、動画、PDF、スプレッドシートを添付（最大サイズ 25 MB）',
  mark_page_active: 'ページ上の項目をクリックしてマーク — Esc でキャンセル',
  mark_page: '質問したいページ上の項目をマーク',
  stop_response: '回答を停止',
  copy_reply: '返信をコピー',
  mentions_empty: '一致する項目はありません',
  copied: 'コピーしました',
  send_message: 'メッセージを送信',
  upload_failed: 'アップロードに失敗しました: {error}',
  remove_attachment: '添付ファイルを削除',
  json_no_items: '項目がありません',
  json_no_data: 'データがありません',
  json_no_chart_data: 'グラフ用のデータがありません',
  json_unsupported: '未対応: {type}',
  json_see_less: '表示を減らす',
  json_phone_agent: '電話エージェント',
  json_phone_agent_test: 'ウェブでテスト',
  page_context_remove: 'ページのコンテキストを削除',
  json_see_more: 'さらに {count} 件表示',
  queued_label: '{count} 送信待ち',
  remove_queued_message: '送信待ちのメッセージを削除',
  send_queued_now: '送信待ちのメッセージを今すぐ送信',
  turn_failed_message: '問題が発生し、回答を受信できませんでした。',
  turn_failed_retry: 'もう一度試す',
  page_mark_hint: 'クリックしてマーク',
  page_mark_escape: 'Esc',
  page_mark_shape_box: '枠',
  page_mark_shape_circle: '円',
  page_mark_shape_arrow: '矢印',
  page_mark_shape_bracket: 'かっこ',
  page_mark_shape_underline: '下線',
  page_mark_shape_highlight: 'ハイライト',
  page_mark_shape_strike_through: '取り消し線',
  page_mark_shape_crossed_off: '×印',
  page_mark_shape_aria: 'マークの形状: {shape}',
  page_mark_note_placeholder: 'メモを追加…（Enter で添付）',
  page_mark_attach: 'マークを添付',
  page_mark_remove: '{label}を削除',
  page_mark_region: 'マークした領域',
  page_mark_default_message: 'これは何ですか？',
  file_rejected: '対応していないファイル形式か、ファイルサイズが大きすぎます。',
  dictate: '音声入力',
  stop_dictation: '音声入力を停止',
  dictation_mic_blocked: '音声入力にはマイクへのアクセスを許可してください',
  dictation_unavailable: '音声入力は現在ご利用いただけません',
  questions_back: '戻る',
  questions_next: '次へ',
  questions_send: '送信',
  questions_type_answer: '自分で入力する',
  questions_answer_placeholder: '回答を入力してください…',
  close_conversation_title: '会話を終了',
  close_conversation_description: 'この会話を終了してもよろしいですか？',
  close_conversation_cancel: 'いいえ',
  close_conversation_confirm: 'はい',
  dialog_close: '閉じる',
  zoom_in: '拡大',
  zoom_out: '縮小',
  reset_zoom: 'ズームをリセット',
  support_chat_aria_label: 'サポートチャット',
};
